import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {ScrollBoxOptions, Scrollbox} from '@colonist/pixi'
import {UIGameEndPlayerNameView} from './UIGameEndPlayerNameView'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGameEndStatsController} from './UIGameEndStatsController'
import {EndGameStateUtils} from '@colonist/game-endgame-types'
import {EndGamePlayerState, EndGameState} from '@colonist/game-states'
import {UIGameManager} from '../UIGameManager'

export class UIGameEndPlayerStatsController extends SectionBgView {
    private readonly uiGameManager: UIGameManager
    private readonly itemSize: number
    private readonly playerEndGameNameViews: UIGameEndPlayerNameView[] = []
    private readonly endGameStatsController: UIGameEndStatsController
    private readonly endGameState: EndGameState
    verticalScrollBox: Scrollbox
    horizontalScrollBox: Scrollbox

    constructor(uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, container: SectionBgView, endGameStatsController: UIGameEndStatsController, endGameState: EndGameState) {
        super(x, y, w, h, container)
        this.uiGameManager = uiGameManager
        this.endGameStatsController = endGameStatsController
        this.itemSize = endGameStatsController.itemSize
        this.endGameState = endGameState

        this.createVerticalScrollBox()
        this.createPlayers(EndGameStateUtils.getPlayersSortedByRank(endGameState.players))
        this.createHorizontalScrollBox()
    }

    private createVerticalScrollBox() {
        const scrollOptions: ScrollBoxOptions = {
            boxWidth: this.width,
            boxHeight: this.height,
            overflowX: 'hidden',
            scrollbarBackgroundAlpha: 0,
            scrollbarSize: this.itemSize / 10,
            events: this.uiGameManager.canvasController.app.renderer.events,
        }
        this.verticalScrollBox = new Scrollbox(scrollOptions)
        this.addChild(this.verticalScrollBox)
    }

    private createPlayers(endGamePlayerStates: EndGamePlayerState[]) {
        const isUserOnMobile = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp
        const playerAvatarAndNameX = (this.itemSize / 2) * (isUserOnMobile ? 0.3 : 1.4)
        const playerAvatarAndNameW = this.itemSize * (isUserOnMobile ? 1.6 : 5)

        const rowHeight = this.endGameStatsController.rowHeight
        const tableHeadHeight = this.endGameStatsController.tableHeadHeight
        for(const [index, endGamePlayerState] of endGamePlayerStates.entries()) {
            const playerY = rowHeight * (index) + tableHeadHeight

            const playerState = this.uiGameManager.gameController.getPlayerState(endGamePlayerState.color)

            const playerEndGameNameView = new UIGameEndPlayerNameView(this.uiGameManager, playerAvatarAndNameX, playerY, playerAvatarAndNameW, this.itemSize, this.verticalScrollBox.content, endGamePlayerState, playerState, this.uiGameManager.gameController.gameDetails.isRanked)
            this.playerEndGameNameViews.push(playerEndGameNameView)
        }
    }

    private createHorizontalScrollBox() {
        const x = this.playerEndGameNameViews[0].x + this.playerEndGameNameViews[0].width
        const horizontalMargin = this.itemSize / 8
        const w = this.verticalScrollBox.contentWidth - x - horizontalMargin
        const h = this.verticalScrollBox.content.height + this.endGameStatsController.tableHeadHeight
        const container = new SectionView(x, 0, w, h, this.verticalScrollBox.content)

        const containerHeight = Math.max(this.verticalScrollBox.contentHeight, container.height)
        const scrollOptions: ScrollBoxOptions = {
            boxWidth: container.width,
            boxHeight: containerHeight,
            overflowY: 'hidden',
            stopPropagation: false,
            scrollbarBackgroundAlpha: 0,
            scrollbarSize: this.verticalScrollBox.scrollbarSize,
            events: this.uiGameManager.canvasController.app.renderer.events,
        }
        this.horizontalScrollBox = new Scrollbox(scrollOptions)
        container.addChild(this.horizontalScrollBox)
    }

    updateHorizontalScrollbox() {
        if(this.horizontalScrollBox.content.width < this.horizontalScrollBox.boxWidth) {
            this.horizontalScrollBox.overflowX = 'hidden'
            this.horizontalScrollBox.content.x = 0
            this.horizontalScrollBox.content.decelerate({friction: 1})
            return
        }
        this.horizontalScrollBox.overflowX = 'scroll'
        this.horizontalScrollBox.content.decelerate({friction: 0.95})
    }
}
